import { useTranslation } from "react-i18next";
import { Tab, TabPane } from "semantic-ui-react";

import { DevicesTable, MetricsTable, UserForm } from "modules/UsersDashboard/components";

type EditUserFormProps = {
  hasErrors: boolean;
  userId: number | null;
  canEditAll: boolean;
  canEditDealerAdminFields: boolean;
  passwordStrength: number;
  onPasswordStrengthChange: (strength: number) => void;
};

export const EditUserForm = ({ userId, hasErrors, canEditAll, canEditDealerAdminFields, passwordStrength, onPasswordStrengthChange }: EditUserFormProps) => {
  const { t } = useTranslation();

  const panes = [
    {
      menuItem: t("v8_devices", "Devices"),
      render: () => (
        <TabPane>
          <DevicesTable userId={userId} />
        </TabPane>
      )
    },
    {
      menuItem: t("v8_metrics", "Metrics"),
      render: () => (
        <TabPane>
          <MetricsTable userId={userId} />
        </TabPane>
      )
    }
  ];

  return (
    <>
      <UserForm
        isEdit
        hasErrors={hasErrors}
        userId={userId}
        canEditAll={canEditAll}
        canEditDealerAdminFields={canEditDealerAdminFields}
        passwordStrength={passwordStrength}
        onPasswordStrengthChange={onPasswordStrengthChange}
      />

      <div className="padding-container" style={{ paddingTop: "0px" }}>
        <Tab panes={panes} />
      </div>
    </>
  );
};
